// js/ui/spellbookSubmenu.js
import { elementFactory } from "./factory.js";
import { ELEMENT_NAMES } from "../assets/elements.js";

export class spellbookSubmenu {
    constructor(containerEl, gameState) {
        this.container = containerEl;
        this.gameState = gameState;

        //console.log(this.container);
        this.ui = {
            elementTabs: this.container.querySelector('.spellbook-element-tabs'),
            gridContainer: this.container.querySelector('.spell-grid-container'),
            inventoryContainer: this.container.querySelector('.spellbook-inventory-container'),
            filterButtons: this.container.querySelectorAll('.inventory-filter-btn'),
            clearBtn: this.container.querySelector('.clear-spell-grid-btn'),
            display: {
                power: this.container.querySelector('.spell-stat-power'),
                speed: this.container.querySelector('.spell-stat-speed'),
                cost:  this.container.querySelector('.spell-stat-cost'),
            },
            elementButtons: [],
            shardInventorySlots: [],
            spellGridSlots: []
        };
        
        this.settings = {}
        this.gridSizeIncrease = 3;
        this.currentElementGridSize = 0;
        this.activeElement = "all";
        this.currentSort = "tier";
    }

    init() {

        this.setupFilters();
        this.selectSpellbookElement(this.activeElement);
       
        this.generateSpellbookElementButtons();
        this.setupElementButtons();
        this.setupSpellGrid();
        this.refreshInventoryStructure();
        
        
        this.setupDragAndDrop();
    }


    setupFilters() {
        this.ui.filterButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                // Sorting & filtering logic goes here
            });
        });

        this.ui.clearBtn.addEventListener('click', () => {
            this.gameState.spellHandler.emptySpellGrid(this.activeElement);
            this.refreshInventoryStructure()
            this.drawSpellGrid();
            this.gameState.uiInfo.updateHuntingSubmenu = true;
        });
    }

    setupElementButtons() {
        this.ui.elementTabs.addEventListener('click', (event) => {
            const clickedButton = event.target.closest('.spellbook-element-button');
            if (!clickedButton) return;
            
            const chosenElement = clickedButton.dataset.element;
            if (chosenElement !== 'none') {
                this.selectSpellbookElement(chosenElement);
                this.gameState.spellHandler.initSpellGrids(chosenElement, this.currentElementGridSize)
                this.updateSpellbookElementButtons();
                this.drawSpellGrid();
                this.refreshInventoryStructure(); // Re-index structure sizes on tab shift
            } else {
                console.log("Error: trying to set formation menu to no element");
            }
        });
    }

    updateSpellbookElementButtons() {
        if (this.ui.elementButtons) {
            this.ui.elementButtons.forEach(btn => {
                btn.classList.toggle('active', btn.dataset.element === this.activeElement);
            });
        }
    }


    getActiveSpellData() {
        if (this.activeElement === "all" || this.activeElement === "none") {
            return this.gameState.spellHandler.getAllSpells(this.currentSort);
        }
        return this.gameState.spellHandler.getAllElementSpellShards(this.activeElement, this.currentSort);
    }

    refreshInventoryStructure() {
        const activeSpells = this.getActiveSpellData();    
        this.ui.shardInventorySlots = elementFactory.createSpellShardInventorySlots(activeSpells.length); 
        this.ui.inventoryContainer.innerHTML = '';
        this.ui.inventoryContainer.append(...this.ui.shardInventorySlots);

    
        this.renderInventory();
    }


    renderInventory() {
        const activeSpells = this.getActiveSpellData();
        //console.log(activeSpells);
        this.gameState.spellHandler.drawInventory(this.ui.shardInventorySlots, activeSpells);
    }

    setupDragAndDrop() {
        const invContainer = this.ui.inventoryContainer;
        const gridContainer = this.ui.gridContainer;

        let draggedSpellId = null;
        let currentSpell = null;
        let shardSize = null;

        let sourceSlot = null
        let sourceInvIndex = null;
        let floatingIcon = null;
        let currentHoveredSlot = null;

        invContainer.addEventListener("pointerdown", (event) => {
            sourceSlot = event.target.closest(".spell-inventory-slot");

            if (!sourceSlot) return;

            sourceSlot.classList.add("dragging");
            
            draggedSpellId = sourceSlot.getAttribute("data-spell-id");
            sourceInvIndex = parseInt(sourceSlot.dataset.index);
            if (!draggedSpellId) return;

            const shardColor = window.getComputedStyle(sourceSlot).getPropertyValue('--color-primary').trim();
            const finalDragColor = shardColor || '#ffffff'; 
            document.body.style.setProperty('--shard-drag-color', finalDragColor);

            currentSpell = this.gameState.spellHandler.getSpellShard(draggedSpellId);
            shardSize = currentSpell?.tier || 1;

            // Prevent default browser behavior (dragging images/text selection text)
            event.preventDefault();

            // 1. Create the floating visual element
            const nativeIcon = sourceSlot.querySelector(".shard-icon");
            if (nativeIcon) {
                let baseSlotSize = "3vw"; 
                if (this.ui.spellGridSlots && this.ui.spellGridSlots.length > 0) {
                    const gridSlotRect = this.ui.spellGridSlots[0].getBoundingClientRect();
                    baseSlotSize = `${gridSlotRect.width}px`;
                }

                const shardColor = window.getComputedStyle(nativeIcon).getPropertyValue('--color-primary').trim();
                const finalDragColor = shardColor || '#ffffff'; 
                document.body.style.setProperty('--shard-drag-color', finalDragColor);


                floatingIcon = nativeIcon.cloneNode(true);
                floatingIcon.classList.add("floating-drag-icon");
                floatingIcon.style.left = `${event.clientX}px`;
                floatingIcon.style.top = `${event.clientY}px`;

                floatingIcon.style.setProperty('--slot-base-size', baseSlotSize);
                floatingIcon.style.setProperty('--shard-size', shardSize);    
                document.body.appendChild(floatingIcon);
            }

            // 2. Bind global movement tracking loops to the window
            window.addEventListener("pointermove", onPointerMove);
            window.addEventListener("pointerup", onPointerUp);
        });

        const onPointerMove = (event) => {
            if (!floatingIcon) return;

            // 1. Smooth cursor tracking (with clamping)
            const padding = window.innerHeight / 40;
            const clampedX = Math.max(padding, Math.min(event.clientX, window.innerWidth - padding));
            const clampedY = Math.max(padding, Math.min(event.clientY, window.innerHeight - padding));
            floatingIcon.style.left = `${clampedX}px`;
            floatingIcon.style.top = `${clampedY}px`;

            // 2. Clear previous highlights
            this.ui.spellGridSlots.forEach(slot => {
                slot.classList.remove(
                    "drag-over", 
                    "drag-border-top", 
                    "drag-border-bottom", 
                    "drag-border-left", 
                    "drag-border-right"
                );
            });

            // 3. Get the real bounding box of your moving SVG icon canvas
            const shardRect = floatingIcon.getBoundingClientRect();

            let bestAnchorSlot = null;
            let shortestDistanceToTopLeft = Infinity;

            // 4. Gather all slots currently intersecting with the shard's bounding box
            const overlappingSlots = this.ui.spellGridSlots.filter(slot => {
                const slotRect = slot.getBoundingClientRect();

                // Check for spatial intersection
                const isOverlapping = (
                    shardRect.left < slotRect.right &&
                    shardRect.right > slotRect.left &&
                    shardRect.top < slotRect.bottom &&
                    shardRect.bottom > slotRect.top
                );

                return isOverlapping;
            });

            // 5. From the overlapping slots, find the one closest to the shard's top-left corner
            overlappingSlots.forEach(slot => {
                const slotRect = slot.getBoundingClientRect();
                
                // Calculate distance from shard's top-left corner to slot's top-left corner
                const distance = Math.hypot(shardRect.left - slotRect.left, shardRect.top - slotRect.top);

                if (distance < shortestDistanceToTopLeft) {
                    shortestDistanceToTopLeft = distance;
                    bestAnchorSlot = slot;
                }
            });

            // 6. If we found a valid anchor, highlight the clean NxN footprint from it
            if (bestAnchorSlot) {
                currentHoveredSlot = bestAnchorSlot;

                const anchorX = parseInt(bestAnchorSlot.dataset.xIndex);
                const anchorY = parseInt(bestAnchorSlot.dataset.yIndex);

                for (let x = 0; x < shardSize; x++) {
                    for (let y = 0; y < shardSize; y++) {
                        const targetGridX = anchorX + x;
                        const targetGridY = anchorY + y;

                        const matchedSlot = this.ui.spellGridSlots.find(slot => 
                            parseInt(slot.dataset.xIndex) === targetGridX && 
                            parseInt(slot.dataset.yIndex) === targetGridY
                        );

                        if (matchedSlot) {
                            // Add the base highlight background color
                            matchedSlot.classList.add("drag-over");

                            // Apply targeted outer borders dynamically based on relative position
                            if (y === 0) matchedSlot.classList.add("drag-border-top");
                            if (y === shardSize - 1) matchedSlot.classList.add("drag-border-bottom");
                            if (x === 0) matchedSlot.classList.add("drag-border-left");
                            if (x === shardSize - 1) matchedSlot.classList.add("drag-border-right");
                        }
                    }
                }
            } else {
                currentHoveredSlot = null;
            }
        };

        const onPointerUp = (event) => {
            // Remove hover styles if dropping outside or inside
            if (currentHoveredSlot) {
                currentHoveredSlot.classList.remove("drag-over");
                
                let xIndex = parseInt(currentHoveredSlot.dataset.xIndex)
                let yIndex = parseInt(currentHoveredSlot.dataset.yIndex)
                const targetGridIndex = [xIndex, yIndex];
                
                
                
                const success = this.gameState.spellHandler.equipShard(draggedSpellId, this.activeElement, targetGridIndex);
                if (success) {
                    this.drawSpellGrid();
                    this.gameState.uiInfo.updateHuntingSubmenu = true;
                }
            }

            // Deep cleanup: Destroy visual clones, reset state flags, tear down window listeners
            if (floatingIcon) {
                floatingIcon.remove();
                floatingIcon = null;
            }
            
            sourceSlot.classList.remove("dragging");
            this.ui.spellGridSlots.forEach(slot => {
                slot.classList.remove(
                    "drag-over", 
                    "drag-border-top", 
                    "drag-border-bottom", 
                    "drag-border-left", 
                    "drag-border-right"
                );
            });

            document.body.style.removeProperty('--shard-drag-color');
            
            document.querySelectorAll('.floating-drag-icon').forEach(icon => icon.remove());

            sourceSlot = null;
            currentSpell = null;
            shardSize = null
            currentHoveredSlot = null;
            draggedSpellId = null;
            sourceInvIndex = null;

            window.removeEventListener("pointermove", onPointerMove);
            window.removeEventListener("pointerup", onPointerUp);
            
            this.renderInventory();
        };
    }
    
    selectSpellbookElement(elementName) {
        this.gameState.uiInfo.currentSpellbookMenu = elementName; 
        this.activeElement = elementName;

        //calculates the current size of the selected element
        if (this.gameState.player.elements[this.gameState.uiInfo.currentSpellbookMenu]) {
            let tier = this.gameState.player.elements[this.gameState.uiInfo.currentSpellbookMenu].tier;
            this.currentElementGridSize = tier + this.gridSizeIncrease;
        } else {
             this.currentElementGridSize = 4 + this.gridSizeIncrease;
        }
        
    }

    generateSpellbookElementButtons() {
        const buttonContainer = this.ui.elementTabs;
        buttonContainer.innerHTML = ''
        this.ui.elementButtons = elementFactory.createSpellbookElementButtons(this.gameState.player.elements);  
        buttonContainer.append(...this.ui.elementButtons);
    }

    drawSpellGrid() {
        this.setupSpellGrid();
        
    }

    setupSpellGrid() {

        //replace this.currentElementGridSize with the current tier of the currently selected element
        this.ui.spellGridSlots = elementFactory.createSpellGridSlots(this.currentElementGridSize); 
        this.ui.gridContainer.innerHTML = '';

        this.ui.gridContainer.style.gridTemplateColumns = `repeat(${this.currentElementGridSize}, 1fr)`;
        this.ui.gridContainer.style.gridTemplateRows = `repeat(${this.currentElementGridSize}, 1fr)`;

        this.ui.gridContainer.append(...this.ui.spellGridSlots);
        this.updateSpellStatDisplay()
        this.drawEquippedSpells();
    }

    drawEquippedSpells() {
        const targetGrid = this.gameState.spellHandler.spellGrids[this.activeElement];
        if (!targetGrid) return;

        this.ui.spellGridSlots.forEach(slot => {
            const x = parseInt(slot.dataset.xIndex);
            const y = parseInt(slot.dataset.yIndex);
            const coordinateKey = `${x},${y}`;

            const occupyingShardId = targetGrid.usedGridSlots.get(coordinateKey);

            if (occupyingShardId) {
                const shardData = targetGrid.equippedShards.get(occupyingShardId);
                const origin = targetGrid.equippedShardOrigins.get(occupyingShardId);

                if (shardData && origin) {
                    slot.setAttribute("data-spell-id", occupyingShardId);

                    // 1. Ask your icon generator to resolve the primary and secondary color pairs 
                    // exactly like it does when rendering your inventory slots!
                    const [primaryColor, secondaryColor] = this.gameState.spellHandler.iconGenerator.generateIconColors(shardData);

                    // 2. Find the cell's position relative to the top-left corner of the item itself
                    const relativeX = x - origin.x;
                    const relativeY = y - origin.y;

                    // 3. Match the exact mathematical pattern your SVG generator uses
                    const isEvenCell = (relativeX + relativeY) % 2 === 0;

                    // 4. Paint the cell matching the internal layout pattern of the shard
                    slot.style.backgroundColor = isEvenCell ? primaryColor : secondaryColor;
                    slot.classList.add("occupied-cell");
                    return;
                }
            }

            // Clean slate for empty grid cells
            slot.style.backgroundColor = "";
            slot.removeAttribute("data-spell-id");
            slot.classList.remove("occupied-cell");
        });
    }

    updateSpellStatDisplay() {
        let stats = this.gameState.spellHandler.calculateSpellStats(this.activeElement);
        //console.log(this.ui.display);

        

        this.ui.display.power.innerText = stats.totalPower;
        this.ui.display.speed.innerText = stats.totalSpeed;
        this.ui.display.cost.innerText = stats.totalMPCost;
        
        // this.ui = {
        //     elementTabs: this.container.querySelector('.spellbook-element-tabs'),
        //     gridContainer: this.container.querySelector('.spell-grid-container'),
        //     inventoryContainer: this.container.querySelector('.spellbook-inventory-container'),
        //     filterButtons: this.container.querySelectorAll('.inventory-filter-btn'),
        //     clearBtn: this.container.querySelector('.clear-spell-grid-btn'),
        //     display: {
        //         power: this.container.querySelector('spell-stat-power'),
        //         speed: this.container.querySelector('spell-stat-speed'),
        //         cost:  this.container.querySelector('spell-stat-cost'),
        //     },
    }

    update() {
        if (this.gameState.uiInfo.newElement.spellbook) {
            this.generateSpellbookElementButtons();
            this.gameState.uiInfo.newElement.spellbook = false;
        }

        if (this.gameState.uiInfo.newShard) {
            this.refreshInventoryStructure();
            this.gameState.uiInfo.newShard = false;
        }
    }
}